// extracted by mini-css-extract-plugin
export var contentBody = "_dr-9";
export var headerImage = "_dr-2";
export var imageButton = "_dr-7";
export var imageButtonIcon = "_dr-8";
export var imageHeader = "_dr-4";
export var imageHeaderText = "_dr-5";
export var imageOverlay = "_dr-3";
export var imageTitle = "_dr-6";
export var imageWrapper = "_dr-1";
export var taskList = "_dr-a";
export var widget = "_dr-0";